<template>
  <div class="modal-form">
    <h3 class="card-title">Cargar sucursal</h3>
    <form @submit.prevent="save">
      <pd-input
        v-model="descripcion"
        id="descripcion"
        label="Descripcion"
        placeholder="Ingrese el nombre de la sucursal"
        class="my-1"
        :required="enviado && !$v.descripcion.required"
      ></pd-input>
      <button class="btn btn-right btn-primary">Guardar</button>
    </form>
  </div>
</template>
<script>
import { SucursalServices } from "../services/SucursalServices";
import Swal from "sweetalert2";
export default {
  name: "NuevaSucursal",
  data() {
    return {
      descripcion: "",
      enviado: false
    };
  },
  validations:{
    ...SucursalServices.validations
  },
  methods: {
    save() {
      this.enviado = true;
      if (!this.descripcion) {
        return false;
      }
      SucursalServices.api.save({
        descripcion: this.descripcion,
      }).then((r) => {
        Swal.fire("Éxito", `<p><b>${r.sucursal.descripcion}</b> se ha guardado con éxito</p>`, 'success');
        this.$emit('saved')
      })
      .catch((e) => {
        Swal.fire("Error", `<p>${e}</p>`, 'error');
      });
    },
  },
};
</script>